import { Tab } from '../../../../../views/customer-base';
import { BillingTypeOptions } from '../../../../../views/customer-base/BillingHealthTab';
import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  tabs: {
    [Tab.Performance]: 'Leistung',
    [Tab.NewCustomers]: 'Neue Restaurants',
    [Tab.CustomerHealth]: 'Kunden Gesundheit',
    [Tab.LiveAndInactive]: 'Live und Inaktiv',
    [Tab.BillingHealth]: 'Rechnungsstellung Gesundheit',
  },
  labels: {
    sales_manager: 'Vertriebsleiter',
  },
  performance_tab: {
    table_columns: {
      name: 'Name',
      sales_manager: 'Vertriebsleiter',
      orders: 'Bestellungen',
      sales: 'Vertrieb',
      previous_month_sales: 'Umsatz Vormonat',
    },
    labels: {
      sales_volume: 'Umsatzvolumen:',
      all: 'Alle',
      click_to_sort: 'Klicken Sie zum Sortieren',
      no_data: 'Keine Daten',
    },
    toasts: {
      failed_to_load_data: 'Daten konnten nicht geladen werden',
    },
  },

  new_restaurants_tab: {
    table_columns: {
      name: 'Name',
      sales_manager: 'Vertriebsleiter',
      orders: 'Bestellungen',
      sales: 'Vertrieb',
      days_live: 'Tage Live',
      early_performance: 'Frühe Leistung',
    },
    labels: {
      click_to_sort: 'Klicken Sie zum Sortieren',
      no_data: 'Keine Daten',
      only_with_early_performance: 'Nur mit früher Leistung: ',
      early_performance_yes: '✔️ Ja',
      early_performance_no: '✗ Nein',
    },
    toasts: {
      failed_to_load_data: 'Daten konnten nicht geladen werden',
    },
  },

  customer_health_tab: {
    titles: {
      sales_tiers: 'Vertriebsklassen',
      payments_ratio: 'Zahlungsverhältnis',
    },
    dataset_labels: {
      negative: 'Negativ ({{values}})',
      ok: 'OK ({{values}})',
      good: 'Gut ({{values}})',
      excellent: 'Ausgezeichnet ({{values}})',
    },

    companies_preview_modal: {
      title: 'Restaurants Vorschau',
      table_columns: {
        name: 'Name',
        sales_manager: 'Vertriebsleiter',
        orders: 'Bestellungen',
        sales: 'Vertrieb',
        total_payments: 'Gesamte Zahlungen',
        payments_ratio: 'Zahlungsverhältnis',
      },
      labels: {
        close: 'Schließen',
        click_to_sort: 'Klicken Sie zum Sortieren',
        no_data: 'Keine Daten',
      },
    },
    toasts: {
      failed_to_load_data: 'Daten konnten nicht geladen werden',
    },
  },

  live_and_inactive_tab: {
    dataset_labels: {
      live: 'Live',
      no_orders: 'Keine Bestellungen',
      no_conversion: 'Keine Konvertierung',
    },
    toasts: {
      failed_to_load_data: 'Daten konnten nicht geladen werden',
    },
  },

  billing_health_tab: {
    filters: {
      billing_type: {
        label: 'Art der Abrechnung',
        options: {
          [BillingTypeOptions.Subscription]: 'Abonnement',
          [BillingTypeOptions.Manual]: 'Andere',
        },
      },
      high_risk_only: {
        label: 'Nur Kunden mit hohem Risiko',
      },
    },
    fields: {
      name: 'Name',
      live_from: 'Live aus',
      billing_mode: {
        title: 'Quelle der Rechnungsstellung',
        options: {
          [BillingMode.Stripe]: 'Zahlungsmethode',
          [BillingMode.InternalInvoicing]: 'Verkäufen',
        },
      },
      trial_ends_at: 'Ende des Prozesses',
      last_failed_invoice_amount: 'Letzter fehlgeschlagener Rechnungsbetrag',
      failed_payments_count: 'Fehlgeschlagene Zahlungen zählen',
    },
    tags: {
      is_high_billing_risk_customer: 'Hohe Abrechnungsrisiken',
    },
    toasts: {
      failed_to_load_data: 'Daten konnten nicht geladen werden',
    },
  },
};
